/**
 * Controllers — pure utilities. No DOM, no state. Bundle-internal
 * (imported by the other modules; never exposed on window).
 */

var Controllers = new Object();

/**
 * Build a tel: href from a display phone number.
 * "1-800-468-4798" → "tel:18004684798"
 *
 * @param  {string} phoneNumber  Display-formatted number
 * @return {string}              tel: href, or '' when no number
 */
Controllers.phoneHref = function (phoneNumber) {

  if (!phoneNumber) return '';

  return 'tel:' + String(phoneNumber).replace(/[^0-9+]/g, '');

};

/**
 * Whether the Intercom messenger is available on this page: the page must
 * have Intercom enabled (thryvData.intercom_status — the "Toggle Intercom"
 * page setting, same flag GTM boots from) AND the Intercom API must have
 * actually loaded.
 *
 * @return {boolean}
 */
Controllers.intercomAvailable = function () {

  if (window.thryvData && window.thryvData.intercom_status === false) return false;

  return typeof window.Intercom === 'function';

};

/**
 * Presence for the online dot — true when within the configured business
 * hours, or always when hours is null (24/7, per the Call modal copy).
 *
 * @param  {object|null} hours  Config.hours — { timeZone, days, open, close }
 * @return {boolean}
 */
Controllers.online = function (hours) {

  if (!hours) return true;

  try {

    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: hours.timeZone,
      weekday: 'short',
      hour: 'numeric',
      hour12: false,
    }).formatToParts(new Date());

    var byType = {};

    parts.forEach(function (part) { byType[part.type] = part.value; });

    var day = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(byType.weekday);
    var hour = parseInt(byType.hour, 10) % 24;

    return hours.days.indexOf(day) > -1 && hour >= hours.open && hour < hours.close;

  } catch (e) {

    return true; // unknown timezone/Intl failure — fail open, not offline

  }

};

/**
 * Collapsed-state persistence — the visitor's choice to tuck the bar away
 * holds for the session (sessionStorage; private-mode failures = expanded).
 *
 * @return {boolean}
 */
Controllers.storedCollapsed = function () {

  try {

    return sessionStorage.getItem('thryv_cb_collapsed') === '1';

  } catch (e) {

    return false;

  }

};

export default Controllers;
